import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {ResourceOption} from '../../graphql/resources.datatypes';

interface ResourceOptionData {
    resourceOption: ResourceOption
}

export const gqlResourceOption = `
  id
  resource_id
  internal_name
  display_name
  description
  disabled
  hidden
  additional_charge
  target
  action_type
  action_value
  editing_level
  view_level
  
  conditions {
    id
    type
    attribute
    attribute_type
    attribute_value
    condition
  }
  
  groupResources {
    id
    unitCost
    
    roomMemberOptions {
        id
        unit_cost
        unit_count
    }
    roomOptions {
        id
        unit_cost
        unit_count
    }
}
`;

export const GET_RESOURCE_OPTION_QUERY = gql`
  query getResourceOption($id: Int!) {
    resourceOption(id: $id) {
      ${gqlResourceOption}
    }
  }
`;

export const getResourceOption = (resourceOptionId: number | null) => {
  const id = resourceOptionId? resourceOptionId : -1;
  return useQuery<ResourceOptionData>(
    GET_RESOURCE_OPTION_QUERY,
    {
      variables: {id},
      
    }
  );
};

export default getResourceOption;